import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#307FE2",
      fillRule: "evenodd",
      d: "m12.341 12.77 7.088-7.087v6.531a.786.786 0 1 0 1.571 0V3.786a.783.783 0 0 0-.229-.554l-.003-.004A.783.783 0 0 0 20.217 3h-8.431a.786.786 0 0 0 0 1.571h6.531L11.23 11.66a.786.786 0 0 0 1.111 1.11Zm2.304 5.935a2.502 2.502 0 0 0 2.21-2.213c.097-.874.145-1.832.145-2.242 0-.41-.34-.75-.75-.75s-.75.34-.75.75 0 .75-.1 1.75c-.1.995-.4 1.2-1.4 1.26-.562.034-1.5.14-1.5.14v3.1l-3.05-3c-1.5 0-2.75-.048-4.45-.219-1.205-.12-1.4-.5-1.45-1.781l-.002-.06A46.304 46.304 0 0 1 3.5 13.5c0-.706.024-1.5.1-2 .157-1.036.486-1.514 1.707-1.719C6.613 9.562 8 9.5 9.032 9.5h.718c.41 0 .75-.34.75-.75S10.16 8 9.75 8h-.718C8 8 7 8 5.307 8.251c-2.295.34-3.04 1.502-3.18 3.202A36.156 36.156 0 0 0 2 14c0 .5.047 1.61.143 2.483a2.502 2.502 0 0 0 2.217 2.216C7 19 8.5 19 8.836 18.998l2.613 2.571A1.498 1.498 0 0 0 14 20.498V18.77c.22-.02.436-.043.645-.066Z",
      clipRule: "evenodd"
    }
  )
);
var SvgSmsOutboundOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var SmsOutboundOutlined_default = SvgSmsOutboundOutlined;

export { SmsOutboundOutlined_default as default };
